(function (window, $j) {
    var setTabActive = function () {
        // For nav-tabs
        if ($j("#myTab.nav-tabs > li").not(".tabdrop").length > 0) {
            $j("#myTab.nav-tabs .dropdown-menu li > a").attr("aria-selected", "false");
            $j("#myTab.nav-tabs .dropdown-menu li.active").removeClass("active");
            
            $j("#myTab.nav-tabs > li").removeClass("active");
            $j("#myTab.nav-tabs > li > a").attr("aria-selected", "false");
            $j("#myTab.nav-tabs > li").first().addClass("active");
            $j("#myTab.nav-tabs > li > a").first().attr("aria-selected", "true");

        }
        // For tab-pane 
        // reset all
        $j(".feature-tabs .tab-content div").attr("aria-selected", "false");
        $j(".feature-tabs .tab-content div").removeClass("active");
        // activate
        $j(".feature-tabs .tab-content div:first-child").addClass("active");
        $j(".feature-tabs .tab-content div:first-child").attr("aria-selected", "true");
    };
    $j(document).ready(function () {
        $j("#myTab.nav-tabs").tabdrop('layout');
        setTabActive();
        $j("#myTab.nav-tabs a").bind("click", function (e) {
            e.preventDefault();
            var thisTab = $j(this).attr("href");
            if (thisTab != "#") {
                $j("#myTab.nav-tabs li.active > a").attr("aria-selected", "false");
                $j("#myTab.nav-tabs li.active").removeClass("active");
                $j(this).parent().addClass("active");
                $j(this).attr("aria-selected", "true");
                if ($j(".feature-tabs").length > 0)
                {
                    $j(".feature-tabs .tab-content .tab-pane").attr("aria-selected", "false");
                    $j(".feature-tabs .tab-content .tab-pane").removeClass("active");
                    $j(".feature-tabs .tab-content #" + thisTab).attr("aria-selected", "true");
                    $j(".feature-tabs .tab-content #" + thisTab).addClass("active");
                }
                //For tabdrop functionality - on PhotoGallery pages                
                if ($j("#gallery").length > 0) {
                    var tabId = $j(this).attr("href").replace('#', '');
                    //Adding '#gallery' to fix Olapic issue
                    $j("#gallery .tab-content div.active").attr("aria-selected", "false");
                    $j("#gallery .tab-content div.active").removeClass("active");
                    $j("#gallery .tab-content").find("div[id='" + tabId + "']").addClass("active");
                    $j("#gallery .tab-content").find("div[id='" + tabId + "']").attr("aria-selected", "true");
                }
                
            }
            if ($j(this).attr("id") === "tabdrop-menu") {
                // If we have selected the tabdrop menu, we want to make it active so it has proper styling, but we don't want to do the added logic.
                $j("#myTab.nav-tabs li.active > a").attr("aria-selected", "false");
                $j("#myTab.nav-tabs li.active").removeClass("active");
                $j(this).parent().addClass("active");
                $j(this).attr("aria-selected", "true");
            }
            
        });
    });
})(window,$j);